var aside = {
	selectors: { },

	init: function () {
		var self = this;

		self.activeMenu();
		self.breadcrumbs();
	},

	breadcrumbs: function() {
		var self = this;
		var breadcrumbs		= [];
		var breadcrumbsHtml = '';
		var activeItem 		= jQuery('.aside_nav__item--active');

		if ( ! activeItem.length ) return false;

		// Traverse up to get all parent links
		activeItem.parents('li.aside_nav__item').each(function() {
			var link = jQuery(this).find('> a.aside_nav__link').first();
			if (link.length) {
				breadcrumbs.unshift({
					title: link.text(),
					href: link.attr('href')
				});
			}
		});
		
        jQuery.each( breadcrumbs, function( index, breadcrumb ) {
            breadcrumbsHtml += '<a href="' + breadcrumb.href + '">' + breadcrumb.title + '</a><span class="separator"></span>';
        });

		jQuery( breadcrumbsHtml ).insertBefore( '.breadcrumbs > p .last' );
	},

	activeMenu: function(){
		jQuery( document ).on( 'click', '.aside_nav__item--parent > .aside_nav__link', function( event ){
			event.preventDefault();

			var parent = jQuery( this ).parent();
			parent.find( '> .submenu-toggle' ).trigger( 'click' );
		});

		jQuery( '.aside_nav__item--ancestor--active' ).each(function(){
			jQuery( this ).find( '> .submenu-toggle' ).trigger( 'click' );
		});
	},
};

export { aside };